/**
 * @file Modal that appears when new edges are created. It displays options of edge types that a user can select.
 */

import { Card, Image, List, Modal } from 'antd';
import React from 'react';
import { edgeCreate, edgeCreateCancel } from '../controller/edge';
import { EdgeType } from '../model/edge-model';
import agentImg from './../data/edge-type-images/agent.svg';
import aggregationImg from './../data/edge-type-images/aggregation.svg';
import classificationImg from './../data/edge-type-images/classification.svg';
import consumptionResultImg from './../data/edge-type-images/consumption-result.svg';
import effectImg from './../data/edge-type-images/effect.svg';
import exhibitionImg from './../data/edge-type-images/exhibition.svg';
import generalizationImg from './../data/edge-type-images/generalization.svg';
import generationImg from './../data/edge-type-images/generation.svg';
import influenceImg from './../data/edge-type-images/influence.svg';
import invocationImg from './../data/edge-type-images/invocation.svg';
import instrumentImg from './../data/edge-type-images/instrument.svg';
import taggedImg from './../data/edge-type-images/tagged.svg';
import { ACTIONS, StateInterface } from './App';

interface ModalProps {
  state: StateInterface;
  dispatch: Function;
}

interface EdgeData {
  name: EdgeType;
  img: string;
}

const EdgeTypeSelectionModal: React.FC<ModalProps> = ({ state, dispatch }) => {
  // 使用显式映射，避免枚举顺序变化导致图标错位
  const edgeImageMap: Record<EdgeType, string> = {
    [EdgeType.Consumption]: consumptionResultImg,
    [EdgeType.Tagged]: taggedImg,
    [EdgeType.Bidirectional]: effectImg,
    [EdgeType.Effect]: influenceImg,
    [EdgeType.Instrument]: instrumentImg,
    [EdgeType.Agent]: agentImg,
    [EdgeType.Generation]: generationImg,
    [EdgeType.Invocation]: invocationImg,
    [EdgeType.Aggregation]: aggregationImg,
    [EdgeType.Exhibition]: exhibitionImg,
    [EdgeType.Generalization]: generalizationImg,
    [EdgeType.Classification]: classificationImg,
  };
  const EdgeTypeArray = Object.values(EdgeType) as EdgeType[];

  const edgeData = EdgeTypeArray.map((type: EdgeType) => {
    return {
      name: type,
      img: edgeImageMap[type] || taggedImg,
    };
  });

  const cancelModal = () => {
    edgeCreateCancel();
    dispatch({ type: ACTIONS.EDGE_TYPE_SELECTION, payload: false });
  };
  return (
    <div
      onContextMenu={e => {
        e.preventDefault();
      }}
    >
      <Modal
        open={state.showEdgeTypeSelectonModal}
        title="Choose an edge type:"
        onCancel={cancelModal}
        footer={null}
        width={600}
      >
        <List
          grid={{
            gutter: 12,
            column: 3,
          }}
          dataSource={edgeData as any}
          renderItem={(edge: EdgeData) => (
            <List.Item>
              <Card
                hoverable
                styles={{
                  body: {
                    padding: '0px',
                    height: '70px',
                    marginTop: '10px',
                    marginBottom: '5px',
                    textAlign: 'center',
                  },
                }}
                onClick={() => {
                  edgeCreate(edge.name, state);
                  dispatch({
                    type: ACTIONS.EDGE_TYPE_SELECTION,
                    payload: false,
                  });
                }}
              >
                <div style={{ fontSize: 10, paddingBottom: 4 }}>
                  {edge.name}
                </div>
                <Image src={edge.img} preview={false} height={50} />
              </Card>
            </List.Item>
          )}
        />
      </Modal>
    </div>
  );
};

export default EdgeTypeSelectionModal;
